export default __webpack_public_path__ + "static/media/sort-arrow-up.7b5adbd0.svg";